<template>
    <div v-cloak class="reason-for-denial-widget" :class="{ 'error': getIsValidField() }">
        <div class="widget-contents-container">
            <div class="widget-header">
                <h3>Reason for denial</h3>
                <div class="svg-container widget-close-button" @click="closeWidget">
                    <widget-close-svg />
                </div>
            </div>
            <div class="content-wrapper">
                <h2 class="label-config" :class="{ 'has-errors': getIsValidField() }">
                    The vendor will receive an email with the reason for denial.</h2>
                <div class="gray-container" :class="{ 'has-errors': getIsValidField() }">
                    <div class="custom-textarea">
                        <textarea id="text-area" v-model="denyReason" class="text-area" cols="75" rows="6"
                            placeholder="What is your reason for denying this request"></textarea>
                    </div>
                </div>
                <div class="error-message">Required</div>
            </div>
            <div class="widget-footer">
                <div class="action-container">
                    <app-button :disabled="isLoading" class="cancel-btn" @click="closeWidget">
                        Cancel
                    </app-button>
                    <div class="rigth-buttons">
                        <app-button class="accept-btn" :loading="isLoading" @click="onClickSave">
                            Save and send
                        </app-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template> 

<script>

import EventBus from '@/scripts/event-bus';
const AppButton = () => import('@/components/common/app-button');
const WidgetCloseSvg = () => import('@/components/svg/quick-add/widget-close-svg');
import { PartnerApplicationService } from '@/scripts/services/partner-application/partner-application-service';
import { required } from 'vuelidate/lib/validators';

export default {
    name: 'reason-for-denial-widget',

    components: {
        'app-button': AppButton,
        'widget-close-svg': WidgetCloseSvg,
    },


    props: {
        widget: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            denyReason: '',
            isLoading: false,
        };
    },

    computed: {

    },

    validations() {

        return {
            denyReason: {
                required,
            }
        }
    },

    methods: {
        closeWidget() {
            EventBus.$emit('close-widget', this.widget);
        },

        onClickSave() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                return
            }
            this.isLoading = true;
            PartnerApplicationService.deny({ reason: this.denyReason, applicationId: this.widget.idRequest }).then(() => {
                EventBus.$emit('deny-reason', this.denyReason);
                this.closeWidget()
            }).catch((error) => {
                this.$helpers.showFailNotification(
                    'An error occurred while sending your request.<br/>',
                    { error },
                );
            }).finally(() => {
                this.isLoading = false;
            })

        },

        getIsValidField() {
            const isValid = this.$v.denyReason.$invalid && this.$v.denyReason.$dirty
            return isValid
        },
    },

}

</script>


<style>
.reason-for-denial-widget .gray-container {
    background: #F7F7F8;
    font: normal 16px/1em 'Roboto';
    width: 100%;
    border: 2px solid #CAC6CB;
    padding: 7px 15px;
    border-radius: 20px;
    color: #382153;
}

.reason-for-denial-widget .error-message {
    font: normal normal normal 12px/14px Roboto;
    letter-spacing: 0px;
    color: #877D88;
    display: block;
    margin: 0.3em 0 1.25em 0;
}

.reason-for-denial-widget.error .error-message {
    color: #f30070;
}

.reason-for-denial-widget textarea:focus {
    outline: none;
}

.reason-for-denial-widget .gray-container.has-errors {
    border: 2px solid #F30070;
}

.reason-for-denial-widget .custom-textarea {
    display: flex;
    flex-direction: column;
    font-weight: 400;
    gap: 2px;
    font: normal 16px/1em 'Roboto';
    width: 100%;
    border-radius:20px;
}

.reason-for-denial-widget .text-area {
    resize: none;
    color: #382153;
}

.reason-for-denial-widget .text-area::placeholder {
    color: #CAC6CB;
}

.reason-for-denial-widget .inline-flex {
    display: inline-flex;
    gap: 10px;
    align-items: center;
}

.reason-for-denial-widget .cancel-btn {
    border: 1px solid #CAC6CB;
    border-radius: 20px;
    background: transparent;
    font: normal normal medium 14px/25px Roboto;
    letter-spacing: 0px;
    color: #382153;
    width: 127px !important;
    height: 40px !important;
}

.reason-for-denial-widget .cancel-btn:hover {
    background: #DCDCDC;
    border: 2px solid #CAC6CB;
}

.reason-for-denial-widget .right-buttons {
    display: flex;
    gap: 10px;
}

.reason-for-denial-widget .label-config {
    margin-top: 0;
}

.reason-for-denial-widget {
    font: normal normal normal 16px/20px Roboto;
    letter-spacing: 0px;
    color: #382153;
}

.reason-for-denial-widget .label-config h2 {
    font-size: 16px;
}

.reason-for-denial-widget h2 {
    font: normal bold 16px/24px Roboto;
    letter-spacing: 0px;
    margin-top: 25px;
}

.reason-for-denial-widget.error h2 {
    color: #f30070;
}

.reason-for-denial-widget a {
    font: normal normal normal 16px/11px Roboto;
    letter-spacing: 0px;
    color: #18AEFF;
}

.reason-for-denial-widget.widget .widget-header {
    background: rgb(80, 82, 254);
    background: linear-gradient(90deg, rgba(80, 82, 254, 1) 0%, rgba(75, 201, 254, 1) 100%);
}

.reason-for-denial-widget .action-container {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
</style>